import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
    <footer className="app-footer">
        <span className="footer-copy">&copy; {new Date().getFullYear()} VerDict AI</span>
        <span className="footer-divider">·</span>
        <Link to="/help" className="footer-link">Sign-in help</Link>
        <span className="footer-divider">·</span>
        <Link to="/privacy" className="footer-link">Privacy &amp; Cookie Policy</Link>
        <span className="footer-divider">·</span>
        <Link to="/terms" className="footer-link">Terms of Service</Link>
    </footer>
);

export default Footer;
